<template>
  <div>
    <DeleteModal
      modalId="modal-out-invoice-delete"
      @deleteToggle="deleteItem"
    />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-out-invoice-edit"
      ok-only
      centered
      @hide="onModalHide"
      size="lg"
      :title="$t('hospital.add-surgery-invoice-deposit-invoices')"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col cols="12" md="12" class="mb-2 mt-1">
            <div class="mt-2 mt-md-0 w-100 mx-1">
              <b-form-checkbox
                id="checkbox-1"
                v-model="editDocAndSur"
                name="checkbox-1"
                :value="true"
                :unchecked-value="false"
              >
                {{ $t("surgery.edit-doctor-and-surgery") }}
              </b-form-checkbox>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="mt-2 mt-md-0 w-100 mx-1">
              <b-form-group
                :label="$t('surgery.surgery')"
                label-for="department"
              >
                <v-select
                  v-model="surgerySelected"
                  :disabled="editDocAndSur"
                  label="title"
                  :options="surgeryDataList"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :get-option-label="(option) => option.surgery.title"
                  :placeholder="$t('surgery.choose-surgery')"
                  @open="onSurgerySelectOpen"
                />
              </b-form-group>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="mt-2 mt-md-0 w-100 mx-1">
              <b-form-group
                :label="$t('surgery.Doctor')"
                label-for="department"
              >
                <v-select
                  v-model="doctorSelected"
                  label="title"
                  :disabled="editDocAndSur"
                  :options="doctorDataList"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :get-option-label="(option) => option.name"
                />
              </b-form-group>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="mt-2 mt-md-0 w-100 mx-1">
              <b-form-group :label="$t('common.amount')" label-for="BP">
                <b-form-input
                  id="BP"
                  v-model="EditForm.amount"
                  placeholder="Enter Patient BP"
                />
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("hospital.surgery-deposit-invoices") }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="
              $store.state.app.permissions.includes('store-invoiceOutClinic') &&
              !isHistory
            "
          >
            {{ $t("hospital.add-surgery-invoice-deposit-invoices") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(amount)="data">
            <span class="text-nowrap"> {{ data.item.amount }} IQD </span>
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <ActionsButtons
                v-if="!isHistory"
                :noEdit="true"
                deletePerm="delete-invoiceOutClinic"
                editPerm="invoices"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientInvoiceOutClinic()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <OutClinicInvoice :data="invoice" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormCheckbox,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import vSelect from "vue-select";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const OutClinicInvoice = () =>
  import("@/components/printables/OutClinicInvoice.vue");
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
const ServicePriceAutoComplete = () =>
  import("@/components/common/ServicePriceAutoComplete.vue");

export default {
  components: {
    DeleteModal,
    ServicePriceAutoComplete,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormCheckbox,
    VuePhoneNumberInput,
    AutoComplete,
    OutClinicInvoice,
    vSelect,
  },

  props: ["patientCardId", "isHistory"],
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: "",
        doctor_id: "",
        amount: 0,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        patient_card_id: this.$route.params.id,
        service_id: "",
        amount: 0,
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "surgery.title",
          label: this.$t("surgery.surgery"),
          sortable: true,
        },
        {
          key: "amount",
          label: this.$t("employee.amount"),
          sortable: true,
        },
        {
          key: "doctor.name",
          label: this.$t("surgery.Doctor"),
          sortable: true,
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      invoice: "",
      patientData: {
        name: this.$route.params.name,
      },
      OutClinicInvoice: {
        id: "OutClinicInvoice",
      },
      invoices: [],
      surgeryDataList: [],
      surgerySelected: null,
      editDocAndSur: true,
      disabled: false,
      doctorSelected: null,
      doctorDataList: [],
    };
  },

  mounted() {
    this.disabled = "not_accepted";
    this.getPatientInvoiceOutClinic();
    this.getSurgerys();
  },
  watch: {
    editDocAndSur(newVal) {
      console.log("editDocAndSur", newVal);
      this.disabled = newVal === "accepted" ? false : true;
    },
    surgerySelected(newVal) {
      console.log("surgerySelected", newVal);
      if (newVal === null) {
        this.doctorDataList = [];
        this.doctorSelected = null;
      } else {
      this.doctorDataList = newVal.doctors;
      if (!this.editDocAndSur) {
          this.doctorSelected = newVal.doctors[0];
        }
      }
    },
  },
  methods: {
    printInvoice(item) {
      this.invoice = item;
    },
    async getSurgerys() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `patient-surgery?take=20&filter[patient_card_id]=${this.$route.params.id}&include=surgery,doctors&sort=-id`;

      await this.getList(url);
      this.surgeryDataList = this.all_data.data;
      console.log("surgeryDataList", this.surgeryDataList);
      (this.surgerySelected = this.surgeryDataList[0]),
        (this.doctorSelected = this.surgerySelected.doctors[0]);
    },
    onSurgerySelectOpen() {
      console.log("Surgery select dropdown opened");
      // Add any additional logic you want to execute when the select is opened
    },
    onModalHide() {
      this.disabled = "not_accepted";
      (this.surgerySelected = this.surgeryDataList[0]),
        (this.doctorSelected = this.surgerySelected.doctors[0]);
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          patient_card_id: this.$route.params.id,
          amount: 0,
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = this.$route.params.id;
        this.EditForm.service_id = this.service_id;
        this.EditForm.amount = item.amount;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-out-invoice-edit");
    },
    serviceValue(service) {
      this.EditForm.service_id = service.id;
      this.EditForm.amount = service.price;
    },
    async getPatientInvoiceOutClinic() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/invoices?filter[type]=invoice_insurance_surgery&filter[patient_card_id]=${this.$route.params.id}&page=${this.page}&take=${this.take}&sort=-id&include=service,surgery,patientCard,doctor`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-out-invoice-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/invoices/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientInvoiceOutClinic();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        this.EditForm.patient_card_id = this.$route.params.id;
        this.EditForm.surgery_id = this.surgerySelected.surgery.id;
        this.EditForm.doctor_id = this.doctorSelected.id;
        this.EditForm.type = "invoice_insurance_surgery";

        this.invoices.push(this.EditForm);

        (this.params.form = { invoices: this.invoices }),
          (this.params.path = `/invoices`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getPatientInvoiceOutClinic();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/invoices/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientInvoiceOutClinic();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
